import React, { useEffect, useState } from "react";
import CommonTable from "../common/CommonTable";
import CommonModal from "../common/CommonModal";
import { useNavigate } from "react-router-dom";
import { useUser } from "../Commonfunction/UserContext";
import { getData } from "../Commonfunction/CommonFunction";
import { checkPermission } from "../Commonfunction/NewPermission";
import TopHeading from "../common/TopHeading";
import PermissionMessage from "../common/PermissionMessage";
import DeleteConfirmationModal from "../common/DeleteConfirmationModal";
import { TbEdit } from "react-icons/tb";
import { MdLibraryAdd } from "react-icons/md";
import TaxHeadForm from "../Forms/TaxHeadForm";
import TaxHeadFormByMasterHead from "../Forms/TaxHeadFormByMasterHead";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/style/TaxHead.css";

export default function TaxHead() {
  const { role, setUserAccess } = useUser();
  console.log("role--------", role);
  const [tableData, setTableData] = useState([]);
  const [rowId, setRowId] = useState(null);
  const [customSetSingleData, setCustomSetSingleData] = useState(null);
  const [isAddData, setIsAddData] = useState(false);
  const navigate = useNavigate();
  const [permissionsData, setPermissionsData] = useState();
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalNew, setShowModalNew] = useState(false);
  const [permissionMessage, setPermissionMessage] = useState(false);
  const [expandedRowId, setExpandedRowId] = useState(null);
  console.log("customSetSingleData", customSetSingleData);

  const handleClose = () => {
    setShowModal(false);
    setShowModalNew(false);
    setRowId(null);
    setCustomSetSingleData(null);
    fetchData();
  };

  const fetchDataUserAccess = async (
    method,
    showPopup,
    params,
    goToLink,
    isNewModal
  ) => {
    try {
      const result = await getData("/api/user-access");
      if (result.success) {
        setUserAccess(result);
        console.log("**", checkPermission(role, method, result.permission));
        checkPermission(role, method, result.permission)
          ? showPopup
            ? method === "delete"
              ? (setOpen(true), setRowId(params.id))
              : (setRowId(params.id),
                isNewModal ? setShowModalNew(true) : setShowModal(true))
            : goToLink
            ? navigate(goToLink)
            : ""
          : setPermissionMessage(true);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const fetchData = async () => {
    try {
      const result = await getData("/api/all-tax-heads-listing");
      if (result.success) {
        setTableData(result.data);
        setPermissionsData(result.permission);
        if (!checkPermission("TaxHead", "view", result.permission)) {
          setPermissionMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 2000);
        }
      } else {
        setPermissionsData(result.permission);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const handleRowToggle = (id) => {
    setExpandedRowId(expandedRowId === id ? null : id);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      key: "action",
      label: "Action",
      sortable: false,
      
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            width: "100%",
          }}
        >
          <div className="action-buttons">
            <button
              onClick={() => {
                setIsAddData(true);
                setCustomSetSingleData(params);
                fetchDataUserAccess("add", true, params, "", true);
              }}
              className="action-button download"
              title="Add Tax Head"
            >
              <MdLibraryAdd size={18} />
              <span className="button-tooltip">Add</span>
            </button>
            <button
              onClick={() => {
                setIsAddData(false);
                setCustomSetSingleData(params);
                fetchDataUserAccess("edit", true, params, "", false);
              }}
              className="action-button edit"
              title="Edit Tax Head"
            >
              <TbEdit size={18} />
              <span className="button-tooltip">Edit</span>
            </button>
          </div>
        </div>
      ),
    },
    {
      key: "business_type",
      label: "Business Type",
      sortable: true,
      renderCell: (row) => {
        const groupedTypes = row.types?.reduce((acc, item) => {
          acc[item.type] = acc[item.type] || [];
          acc[item.type].push(item.tax_head_name);
          return acc;
        }, {});

        const isExpanded = expandedRowId === row.id;
        console.log("row", row);

        return (
          <div className="tax-head-cell">
            <div
              className="business-type-header"
              onClick={() => handleRowToggle(row.id)}
            >
              <span className="business-title">{row.business_type}</span>
              <span className={`expand-icon ${isExpanded ? "expanded" : ""}`}>
                {isExpanded ? "−" : "+"}
              </span>
            </div>

            {isExpanded && groupedTypes && (
              <div className="tax-data-container">
                <h3 className="section-title">Tax Heads</h3>
                <div className="tax-types-grid">
                  {Object.entries(groupedTypes).map(([type, names], index) => (
                    <div key={index} className="tax-type-card">
                      <div className="tax-type-header">{type}</div>
                      <div className="tax-names-container">
                        {names.map((name, i) => (
                          <span key={i} className="tax-name-tag">
                            {name}
                          </span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>

                {row.tax_head_rules?.length > 0 && (
                  <div className="tax-rules-container">
                    <h3 className="section-title">Tax Rules</h3>
                    <div className="tax-rules-grid">
                      {row.tax_head_rules.map((rule, idx) => {
                        console.log("tax_head_rule", rule);
                        return (
                          <div key={idx} className="rule-card">
                            <div className="rule-item">
                              <span className="rule-label">Tax:</span>
                              <span className="rule-value">
                                {rule.additional_tax?.replace(/_/g, " ")}
                              </span>
                            </div>
                            <div className="rule-item">
                              <span className="rule-label">Type:</span>
                              <span className="rule-value">{rule.type}</span>
                            </div>
                            <div className="rule-item">
                              <span className="rule-label">Computation:</span>
                              <span className="rule-value">
                                {rule.arithmetic}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const indexedRows =
    tableData.length > 0 &&
    tableData.map((data, index) => ({
      index: index + 1,
      id: data.id,
      types: data.types,
      business_type: data.business_type,
      tax_head_rules: data.tax_head_rules,
    }));

  return (
    <div className="tax-head-container">
      <div className="tax-head-header">
        <TopHeading
          // heading="Tax Head"
          setShowModal={() => fetchDataUserAccess("add", true, "", "", false)}
          isHideBtn={true}
        />
      </div>

      <div className="tax-head-content">
        <CommonTable columns={columns} data={indexedRows || []} />
      </div>

      {open && (
        <DeleteConfirmationModal
          open={true}
          handleClose={() => setOpen(false)}
          request_url={`/api/delete-tax-head/${rowId}`}
          getApi={fetchData}
        />
      )}

      {showModal && (
        <CommonModal
          open={showModal}
          onClose={handleClose}
          title={
            isAddData
              ? "Add Tax Head"
              : rowId
              ? "Edit Tax Head"
              : "Add Tax Head"
          }
          size="large"
        >
          <TaxHeadForm
            onClose={handleClose}
            taxheadSingleData={customSetSingleData}
            isAddData={isAddData}
            tableData={tableData}
            rowId={rowId}
          />
        </CommonModal>
      )}

      {showModalNew && (
        <CommonModal
          open={showModalNew}
          onClose={handleClose}
          title={
            isAddData
              ? "Add Tax Head"
              : rowId
              ? "Edit Tax Head"
              : "Add Tax Head"
          }
          size="large"
        >
          <TaxHeadFormByMasterHead
            onClose={handleClose}
            taxheadSingleData={customSetSingleData}
            isAddData={isAddData}
            tableData={tableData}
            rowId={rowId}
          />
        </CommonModal>
      )}

      {permissionMessage && (
        <PermissionMessage
          open={true}
          handleClose={() => setPermissionMessage(false)}
        />
      )}
    </div>
  );
}
